function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "eiilf9ftla"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#eiilf9ftla)",
  transform: "translate(-883 -119) translate(443 92) translate(-2 -3)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#7C8084",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.75.564c-.504 0-.92.416-.92.92v1.544H1.48c-.504 0-.92.416-.92.92 0 .513.424.92.92.92h.392l1.525 12.737c.045.473.458.817.918.817h10.362c.46 0 .852-.348.917-.802v-.007l1.527-12.744h.391c.504 0 .92-.416.92-.92 0-.505-.416-.92-.92-.92h-4.35V1.483c0-.503-.416-.92-.92-.92H6.75zm.92 1.84h3.652v.624H7.67v-.624zM3.731 4.868h11.53l-1.395 11.728h-8.74L3.732 4.868z",
  transform: "translate(433 21) translate(8.974 8.974)"
})))))));

var SvgIconTrash = function SvgIconTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-trash.6acec416.svg";
export { ForwardRef as ReactComponent };